import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Header from 'View/Component/Header/Header';
import Footer from 'View/Component/Footer/Footer';
import * as S from './NotFoundPage.style';

const NotFoundPage: React.FC = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <>
      <Header />
      <S.PageContainer data-testid="not-found-page">
        <S.Content>
          <S.Dial aria-hidden="true">
            <S.DialNumber>404</S.DialNumber>
          </S.Dial>

          <S.Title>{t('not_found.title')}</S.Title>
          <S.Lead>{t('not_found.text')}</S.Lead>

          <S.Actions>
            <S.PrimaryBtn onClick={() => navigate('/')} data-testid="not-found-home-btn">
              {t('not_found.home_btn')}
            </S.PrimaryBtn>
            <S.SecondaryBtn onClick={() => navigate('/kaufen')} data-testid="not-found-shop-btn">
              {t('not_found.shop_btn')}
            </S.SecondaryBtn>
          </S.Actions>

          <S.QuickLinks>
            <span>{t('not_found.suggestions')}:</span>
            <a onClick={() => navigate('/kontakt')}>{t('nav.contact')}</a>
            <a onClick={() => navigate('/suchanfrage')}>{t('nav.request')}</a>
            <a onClick={() => navigate('/showroom')}>{t('nav.showroom')}</a>
            <a onClick={() => navigate('/uber-mich')}>{t('nav.about')}</a>
          </S.QuickLinks>
        </S.Content>
      </S.PageContainer>
      <Footer />
    </>
  );
};

export default NotFoundPage;
